import store from './localstorage.js'
import i18n from './i18n'  
const uuidv4 = require('uuid/v4');

export default {
    name: 'settings',
    key : 'tcc_config',
    getDistanceUnit: function() {
    	return this.get('distance_unit', 'mi')
    },
    getVolumeUnit: function() {
    	return this.get('volume_unit', 'usgal')
    },
    getCurrency: function() {
    	return this.get('currency', 'usd')
    },
    getCountry: function() {
    	return this.get('country', 'us')
    },
    getFuelConsumptionUnit: function() {
    	return this.get('fuel_consumption_unit', 'mpg')
    },
    getLanguage: function() {
    	return this.get('language', 'en')
    },
    getI18nLocale: function(){
    	return this.getLanguage().toLowerCase()+'-'+this.getCountry().toUpperCase()
    },
    get: function(which, default_value){
    	const k = this.key + '_'+ which;
    	const v = store.getString(k, default_value);
    	return v;
    },
    set: function(which, value){
    	const k = this.key + '_'+ which;
    	//console.log(k+"="+value);
    	store.setString(k, value);
    },
    
    getUUID: function(){
        let key = 'client_uuid'
        let uuid = this.get(key, null)
        if(uuid === null){
            uuid = uuidv4();
            this.set(key, uuid)
        }
        return uuid
    },
    
    setI18nLocale : function(language='', country=''){
    	if(language != ''){
    		this.set('language', language.toLowerCase());
    	}
    	if(country != ''){
    		this.set('country', country.toUpperCase());
    	}

    	let locales = store.getObj('i18n')
    	
    	let t = this.getLanguage()+'-'+this.getCountry()
    	if(locales.includes(t)){
    		i18n.locale = t

    	} else {
    		let lang = this.getLanguage();
    		for(var l in locales){
    			if(locales[l].startsWith(lang)){
    				i18n.locale = locales[l];
    				this.set('country', locales[l].split('-')[1]);
    				break;
    			}
    		}
    	}
    },
    setMeasurementSystem : function(which){
		this.set('measurement_system', which);
    	
    	switch(which) {
	    	case 'metric':
	    		this.set('fuel_consumption_unit', 'lp100km');
	    		this.set('volume_unit', 'l');
	    		this.set('distance_unit', 'km');
	    		break;
	    	case 'us':
	    		this.set('fuel_consumption_unit', 'mpg');
	    		this.set('volume_unit', 'usgal');
	    		this.set('distance_unit', 'mi');
	    		break;
	    	case 'uk':
	    		this.set('fuel_consumption_unit', 'mpg');
                //this.set('volume_unit', 'ukgal');
                this.set('volume_unit', 'l');
	    		this.set('distance_unit', 'mi');
	    		break;
    	}
    },
    setDefaults : function(){
    	/*
    	 * First grab this app's defaults
    	 * 
    	 */
    	let defsys  = 'metric'
    	let defcurrency = this.getCurrency()
    	let deflang = this.getLanguage()
    	let defcountry = this.getCountry()
    	
    	// get list of available languages
    	let locales = store.getObj('i18n')
    	let langs = locales.map(x => x.split('-')[0].toLowerCase()) 
    	
    	// now based on what we find in navigator languages try to guess what the user wants
    	for(let n in navigator.languages){
    	    let l = navigator.languages[n].toLowerCase()
    		if(['us'].includes(l.split('-')[1])){
    			// thank goodness only one country has this unit system
    			defsys = "us"
    			defcurrency = "usd"
    			break;
    		}
    		else if(['gb'].includes(l.split('-')[1])){
    			// thank goodness only one country has this unit system
    			defsys = "uk"
    			defcountry = 'GB'
    			defcurrency = 'gbp'
    			break;
    		}
    		else if(langs.includes(l)){
    			deflang = l
    			break;
    		}
    		else if(langs.includes(l.split('-')[0])){
    			deflang = l.split('-')[0]
    			defcountry = l.split('-')[1]
    			break;
    		}
    	}
    	if(['fr'].includes(deflang)){
    		defcurrency = 'eur'
    	}
    	
    	// not already set, set it
    	if(this.get('language', '--') == '--'){
        	this.setI18nLocale(deflang, defcountry)
    	}
    	if(this.get('currency', '--') == '--'){
    		this.set('currency',defcurrency )
    	}
    	if(this.get('measurement_system', '--') == '--'){
    		this.setMeasurementSystem(defsys)
    	}
    }
}